

const ProfileSettings = ()=> {
    return(
        <div>
            Profile settings
        </div>
    )
}

export default ProfileSettings;